const state = {
  sessionPairKey: '815a8fd8-4c5e-4c20-9659-0ae5b44e6fcc',
  isSessionPaired: false,
  user: {
    UserID: '',
    Token: '',
    PhotoURL: null,
    StatusText: 'Hakkımda'
  }
}

const getters = {}

const mutations = {
  setUser (state, data) {
    state.user = data
  },

  setSessionPaired (state, data) {
    state.isSessionPaired = data
  }
}

const actions = {
  setUser (context, data) {
    context.commit('setUser', data)
  },
  setSessionPaired (context, data) {
    context.commit('setSessionPaired', data)
  }
}
export default {
  state,
  getters,
  mutations,
  actions
}
